import PropTypes from 'prop-types'

import { Filters } from 'components'

import constants from 'constants/index'

const RegulationFilter = ({ filter }) => {
  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Título" name="title" />
      <select textfieldinput="true" label="Plataforma" name="platform">
        <option value=""></option>
        {constants.regulations.PLATFORMS_OPTIONS.map((platform) => (
          <option key={platform.id} value={platform.id}>
            {platform.name}
          </option>
        ))}
      </select>
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        {Object.values(constants.regulations.STATUSES).map((status) => (
          <option key={status} value={status}>
            {constants.regulations.STATUS_LABEL[status]}
          </option>
        ))}
      </select>
    </Filters>
  )
}

RegulationFilter.propTypes = {
  filter: PropTypes.object,
}

export default RegulationFilter
